<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1300px"
      title="添加 冲销单"
      line-form
      :data="data"
      form-label-width="110px"
      @create-opened="onCreateOpened"
      :form-rules="rules"
      @closed="onClosed"
    >
      <template slot="form">
        <el-row class="border">
          <el-row>
            <el-col :span="6">
              <el-form-item label="单据编号" prop="DocNo">
                <span class="detail-span" v-if="Mode==0">{{data.DocNo}}</span>
                <el-input v-else v-model="data.DocNo" placeholder="请输入单据编号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="单据日期" prop="DocDate">
                <el-date-picker
                  type="date"
                  v-model="data.DocDate"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="经办人" prop="ClerkId">
                <select-input
                  placeholder="请选择经办人"
                  :label="data.ClerkName"
                  v-model="data.ClerkId"
                  @click="openEmp"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item label="冲销类型">
                <span class="detail-span" v-if="data.CancelTypeId==0">预收冲应收</span>
                <span class="detail-span" v-if="data.CancelTypeId==1">预付冲应付</span>
                <span class="detail-span" v-if="data.CancelTypeId==2">应收冲应收</span>
                <span class="detail-span" v-if="data.CancelTypeId==3">应付冲应付</span>
                <span class="detail-span" v-if="data.CancelTypeId==4">应收冲应付</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="FirstUnitLabel">
                <span class="detail-span">{{data.FirstUnitName}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="转入结算单位" v-if="data.CancelTypeId>1">
                <span class="detail-span">{{data.SecondUnitName}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="备注">
            <el-input size="mini" type="textarea" v-model="data.Memo" placeholder="请输入备注"></el-input>
          </el-form-item>
        </el-row>
        <!-- 预收冲应收、预付冲应付 -->
        <template v-if="data.CancelTypeId==0||data.CancelTypeId==1">
          <div class="row-tb-head" style="margin:10px 0;">{{Tb1Label}}</div>
          <el-table
            class="tb-c-head"
            border
            show-summary
            :data="data.SRpDts"
            @selection-change="x=>data.RpDts=x"
          >
            <el-table-column type="selection" width="45" align="center" />
            <el-table-column label="单据日期" min-width="120">
              <template slot-scope="{row}">{{$commonJs.toDateString(row.DocDate)}}</template>
            </el-table-column>
            <el-table-column label="单据编号" min-width="150" show-overflow-tooltip>
              <template slot-scope="{row}">{{row.DocNo}}</template>
            </el-table-column>
            <el-table-column label="单据类型" min-width="100">
              <template slot-scope="{row}">{{row.SourceTypeName}}</template>
            </el-table-column>
            <el-table-column label="往来单位" min-width="150">
              <template slot-scope="{row}">{{row.TradeUnitName}}</template>
            </el-table-column>
            <el-table-column label="金额" prop="Amount" width="90" />
            <el-table-column label="应冲销金额" prop="NoSettleAmount" width="90" />
            <el-table-column label="冲销金额" prop="WriteoffAmount" width="120">
              <template slot-scope="{row}">
                <el-input size="mini" @input="onInput(row)" v-model="row.WriteoffAmount"></el-input>
              </template>
            </el-table-column>
          </el-table>
        </template>
        <!-- 应收冲应付 -->
        <template v-if="data.CancelTypeId==4">
          <div class="row-tb-head" style="margin:10px 0;">{{Tb1Label}}</div>
          <el-table
            class="tb-c-head"
            border
            show-summary
            :data="data.SWoDts2"
            @selection-change="x=>data.WoDts2=x"
          >
            <el-table-column type="selection" width="45" align="center" />
            <el-table-column label="单据日期" min-width="120">
              <template slot-scope="{row}">{{$commonJs.toDateString(row.DocDate)}}</template>
            </el-table-column>
            <el-table-column label="单据编号" min-width="150" show-overflow-tooltip>
              <template slot-scope="{row}">{{row.DocNo}}</template>
            </el-table-column>
            <el-table-column label="单据类型" min-width="110">
              <template slot-scope="{row}">{{row.SourceTypeName}}</template>
            </el-table-column>
            <el-table-column label="往来单位" min-width="150">
              <template slot-scope="{row}">{{row.TradeUnitName}}</template>
            </el-table-column>
            <el-table-column label="金额" prop="Amount" width="90" />
            <el-table-column label="应冲销金额" prop="NoSettleAmount" width="90" />
            <el-table-column label="冲销金额" prop="WriteoffAmount" width="120">
              <template slot-scope="{row}">
                <el-input @input="onInput(row)" v-model="row.WriteoffAmount"></el-input>
              </template>
            </el-table-column>
          </el-table>
        </template>
        <div class="row-tb-head" style="margin:10px 0;">{{Tb2Label}}</div>
        <el-table
          class="tb-c-head"
          border
          show-summary
          :data="data.SWoDts"
          @selection-change="x=>data.WoDts=x"
        >
          <el-table-column type="selection" width="45" align="center" />
          <el-table-column label="单据日期" min-width="120">
            <template slot-scope="{row}">{{$commonJs.toDateString(row.DocDate)}}</template>
          </el-table-column>
          <el-table-column label="单据编号" min-width="150" show-overflow-tooltip>
            <template slot-scope="{row}">{{row.DocNo}}</template>
          </el-table-column>
          <el-table-column label="单据类型" min-width="110">
            <template slot-scope="{row}">{{row.SourceTypeName}}</template>
          </el-table-column>
          <el-table-column label="往来单位" min-width="150">
            <template slot-scope="{row}">{{row.TradeUnitName}}</template>
          </el-table-column>
          <el-table-column label="金额" prop="Amount" width="90" />
          <el-table-column label="应冲销金额" prop="NoSettleAmount" width="90" />
          <el-table-column label="冲销金额" prop="WriteoffAmount" width="120">
            <template slot-scope="{row}">
              <el-input size="mini" @input="onInput(row)" v-model="row.WriteoffAmount"></el-input>
            </template>
          </el-table-column>
        </el-table>
      </template>
      <template slot="footer">
        <el-button size="mini" type="primary" @click="save">保 存</el-button>
        <el-button size="mini" @click="close">关 闭</el-button>
      </template>
      <emp-dialog ref="empDialog" in-dialog selectable @select="setEmp" />
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import empDialog from "@/components/sales/business/empDialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    empDialog,
  },
  data() {
    return {
      api: require("@/api/fund/contactcash/chargeoff").default,
      code_api: require("@/api/sy/bill").default,
      receipt_api: require("@/api/fund/receipt").default,
      // woDoc_api: require("@/api/rp/woDoc").default,
      // pay_api: require("@/api/rp/pay").default,
      woDoc_api:require("@/api/fund/contactcash/woDoc").default,
      pay_api:require("@/api/fund/paydoc").default,
      data: {
        SettleDocId: 0,
        CancelTypeId: 0, //收款冲销/付款冲销
        DocNo: "",
        FirstUnitId: null,
        FirstUnitName: "",
        SecondUnitId: null,
        SecondUnitName: "",
        DocDate: this.$commonJs.getToday(),
        ClerkId: null,
        ClerkName: "",
        Memo: "",
        RpDts: [], //冲销单收付款单
        SRpDts: [],
        WoDts: [], //冲销单冲销明细
        SWoDts: [],
        WoDts2: [],
        SWoDts2: [],
      },
      Mode: 0,
      rules: {
        DocNo: [{ required: true, message: "收入单编号不能为空" }],
        DocDate: [{ required: true, message: "单据日期不能为空" }],
        ClerkId: [{ required: true, message: "请选择经办人" }],
      },
    };
  },
  computed: {
    FirstUnitLabel() {
      if (this.data.CancelTypeId < 2) return "往来单位";
      else return "转出结算单位";
    },
    Tb1Label() {
      if (this.data.CancelTypeId == 0) return "预收明细";
      else if (this.data.CancelTypeId == 1) return "预付明细";
      else if (this.data.CancelTypeId == 4) return "应收明细";
      else return "单据明细";
    },
    Tb2Label() {
      if (this.data.CancelTypeId == 0) return "应收明细";
      else if (this.data.CancelTypeId == 1) return "应付明细";
      else if (this.data.CancelTypeId == 4) return "应付明细";
      else return "单据明细";
    },
    SelectAmount() {
      var list = this.data.RpDts.map((x) => x.WriteoffAmount);
      if (list.length > 0) return list.reduce((a, b) => a + b);
      else return 0;
    },
  },
  watch: {
    SelectAmount() {
      var s_amount = this.SelectAmount;
      for (let i = 0; i < this.data.SWoDts.length; i++) {
        var ns_amount = this.data.SWoDts[i].NoSettleAmount;
        var amount = s_amount - ns_amount;
        
        if (amount >= 0) {
          this.data.SWoDts[i].WriteoffAmount = ns_amount;
          s_amount = amount;
        } else {
          this.data.SWoDts[i].WriteoffAmount = s_amount;
          break;
        }
      }
    },
  },
  methods: {
    onCreateOpened(data) {  
      
      this.code_api.getDefaultSerialNo("冲销单").then((res) => {
        if (res.Code == 0) {
          this.Mode = res.Data.Mode;
          this.data.DocNo = res.Data;
        } else {
          this.$message.warning("获取冲销单编号失败");
        }
      });
      this.data.CancelTypeId = data.BusinessType;
      this.data.FirstUnitId = data.FirstUnitId;
      this.data.FirstUnitName = data.FirstUnitName;
      this.data.SecondUnitId = data.SecondUnitId;
      this.data.SecondUnitName = data.SecondUnitName;

      var user = this.$store.state.user;
      // 
      this.data.ClerkId = user.empId;
      this.data.ClerkName = user.name;

      var params = {
        DocDateStart: data.DocDateStart,
        DocDateEnd: data.DocDateEnd,
      };

      //预收冲应收、预付冲应付、应收冲应收、应付冲应付、应收冲应付
      if (this.data.CancelTypeId == 0) {
        var params1 = {
          ...params,
          TradeUnitId: data.FirstUnitId,
          BusinessTypes: [1],
        };
        this.alreadyList(params1, "receipt");
        var params2 = { ...params, TradeUnitId: data.FirstUnitId };
        this.needDetail(params2, "needRcvDetail");
      } else if (this.data.CancelTypeId == 1) {
        var params1 = {
          ...params,
          TradeUnitId: data.FirstUnitId,
          BusinessTypes: [1],
        };
        this.alreadyList(params1, "pay");
        var params2 = { ...params, TradeUnitId: data.FirstUnitId };
        this.needDetail(params2, "needPayDetail");
      } else if (this.data.CancelTypeId == 2) {
        var params1 = { ...params, TradeUnitId: data.FirstUnitId };
        this.needDetail(params1, "needRcvDetail");
      } else if (this.data.CancelTypeId == 3) {
        var params1 = { ...params, TradeUnitId: data.FirstUnitId };
        this.needDetail(params1, "needPayDetail");
      } else if (this.data.CancelTypeId == 4) {
        var params1 = { ...params, TradeUnitId: data.FirstUnitId };
        this.needDetail(params1, "needRcvDetail", "SWoDts2");
        var params2 = { ...params, TradeUnitId: data.SecondUnitId };
        this.needDetail(params2, "needPayDetail");
      }
    },
    alreadyList(params, type) {
      var func = this.pay_api.alreadyPayDocList;
      if (type == "pay") func = this.pay_api.alreadyPayDocList;
      else func = this.receipt_api.alreadyList;

      func(params).then((res) => {
        if (res.Data) {
          this.data.SRpDts = res.Data.map((x, i) => {
            var amount = type == "pay" ? x.PayAmount : x.ReceiptAmount;
            return {
              Index: i,
              SettleDocRpId: 0,
              SettleDocId: this.data.SettleDocId,
              SourceTypeId: x.SourceTypeId,
              SourceTypeName: x.SrcVouTypeName,
              DocId: x.DocId,
              DocNo: x.DocNo,
              TradeUnitId: x.TradeUnitId,
              TradeUnitName: x.TradeUnitName,
              DocDate: x.DocDate,
              // DpId: null,
              ClerkId: x.EmpId,
              ClerkName: x.EmpName,
              // ProjectId: null,
              Amount: amount,
              NoSettleAmount: amount - x.WriteoffAmount,
              WriteoffAmount: amount - x.WriteoffAmount,
              TotalAmount: x.WriteoffAmount,
              Memo: "",
              BusinessTypeId: x.BusinessType,
              SourceVoucherId: x.SourceId,
              SourceVoucherTypeId: x.SourceType,
              SourceCode: x.SourceNo,
              IsSelected: false,
              T: 0,
            };
          });
        }
      });
    },
    needDetail(data, type, listType = "SWoDts") {
      
      this.woDoc_api[type](data).then((res) => {
        if (res.Data) {
          this.data[listType] = res.Data.map((x, i) => {
            return {
              Index: i,
              SettleDocWoId: 0,
              SettleDocId: this.data.SettleDocId,
              SourceTypeId: x.SrcVouType,
              SourceTypeName: x.SrcVouTypeName,
              DocId: x.DocId,
              DetailId: x.DetailId,
              DetailName: x.DetailName,
              DocNo: x.DocNo,
              // TypeId: 0,
              TradeUnitId: x.TradeUnitId,
              TradeUnitName: x.TradeUnitName,
              DocDate: x.DocDate,
              DpId: x.DpId,
              DpName: x.DpName,
              ClerkId: x.EmpId,
              ClerkName: x.EmpName,
              // ProjectId: 0,
              Amount: x.Amount,
              NoSettleAmount: x.Amount - x.WriteoffAmount,
              WriteoffAmount: 0,
              TotalAmount: x.WriteoffAmount,
              Memo: "",
              BusinessTypeId: 0,
              SourceVoucherId: x.SourceId,
              SourceVoucherTypeId: x.SrcVouType,
              // SourceCode: null,
              IsSelected: false,
              T: 0,
            };
          });
        }
      });
    },
    openEmp() {
      this.$refs.empDialog.open().then((that) => {
        that.getData({ Status: 1 });
      });
    },
    setEmp(data) {
      this.data.ClerkId = data.EmpId;
      this.data.ClerkName = data.EmpName;
    },
    onInput(row) {
      row.T = row.T == 0 ? 0 : 1;
      row.WriteoffAmount = this.$commonJs.obj.toNumber(row.WriteoffAmount);
      if (row.WriteoffAmount > row.NoSettleAmount) {
        row.WriteoffAmount = row.NoSettleAmount;
      }
    },
    save() {
      this.$refs.dialog.formValidate().then((valid) => {
        if (!valid) return;

        if (this.data.CancelTypeId == 0 || this.data.CancelTypeId == 1) {
          if (this.data.RpDts.length == 0) {
            this.$message.warning("请选择" + this.Tb1Label);
            return;
          }
          var amount1 = this.data.RpDts.some((x) => x.WriteoffAmount <= 0);
          if (amount1) {
            this.$message.warning(
              this.Tb1Label + " - 本次冲销金额不能为空且需大于0"
            );
            return false;
          }
        }

        if (this.data.CancelTypeId == 4) {
          if (this.data.WoDts2.length == 0) {
            this.$message.warning("请选择应收明细");
            return;
          }
          var amount1 = this.data.WoDts2.some((x) => x.WriteoffAmount <= 0);
          if (amount1) {
            this.$message.warning("应收明细 - 本次冲销金额不能为空且需大于0");
            return false;
          }
        }

        if (this.data.WoDts.length == 0) {
          this.$message.warning("请选择" + this.Tb2Label);
          return;
        }
        var amount2 = this.data.WoDts.some((x) => x.WriteoffAmount <= 0);
        if (amount2) {
          this.$message.warning(
            this.Tb2Label + " - 本次冲销金额不能为空且需大于0"
          );
          return false;
        }

        if (this.data.CancelTypeId == 0 || this.data.CancelTypeId == 1) {
          var total1 = this.data.RpDts.map((x) => x.WriteoffAmount).reduce(
            (a, b) => parseFloat(a) + parseFloat(b)
          );
          var total2 = this.data.WoDts.map((x) => x.WriteoffAmount).reduce(
            (a, b) => parseFloat(a) + parseFloat(b)
          );
          if (total1 != total2) {
            var text1 = "已选" + this.Tb1Label + "金额总和";
            var text2 = "已选" + this.Tb2Label + "金额总和";
            this.$message.warning(text1 + "需等于" + text2);
            return false;
          }
        }

        if (this.data.CancelTypeId == 4) {
          var total1 = this.data.WoDts2.map((x) => x.WriteoffAmount).reduce(
            (a, b) => parseFloat(a) + parseFloat(b)
          );
          var total2 = this.data.WoDts.map((x) => x.WriteoffAmount).reduce(
            (a, b) => parseFloat(a) + parseFloat(b)
          );
          if (total1 != total2) {
            var text1 = "已选" + this.Tb1Label + "金额总和";
            var text2 = "已选" + this.Tb2Label + "金额总和";
            this.$message.warning(text1 + "需等于" + text2);
            return false;
          }
        }

        var data = this.$commonJs.obj.removeNullKey(this.data);
        
        this.$refs.dialog.isLoading = true;
        this.api.save(data).then((res) => {
          this.$refs.dialog.isLoading = false;
          if (res.Code == 0) {
            this.$message.success(res.Msg);
            this.$emit("close-saved");
            this.close(true);
          } else {
            this.$message.error(res.Msg);
          }
        });
      });
    },
    onClosed() {
      this.data.RpDts = []; //冲销单收付款单
      this.data.SRpDts = [];
      this.data.WoDts = []; //冲销单冲销明细
      this.data.SWoDts = [];
      this.data.WoDts2 = []; //冲销单冲销明细2
      this.data.SWoDts2 = [];
    },
  },
};
</script> 
<style lang="scss" scoped>
.border{
  padding: 15px;
}
</style>